import styled from 'styled-components'

export const Icon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  height: 100%;
  width: 100%;
  overflow: hidden;
  & img {
    max-height: 100%;
  }
`
